import { API } from './axios';
import { URLS } from './urls';

// Fonction pour soumettre le devis au backend
export const submitQuoteToBackend = async (formData, selectedProducts, userInputs) => {
  let quoteData = null; // Déclarer quoteData en dehors du try pour l'utiliser dans le catch
  
  try {
    console.log('=== DÉBUT SOUMISSION DEVIS ===');
    console.log('FormData actuel:', formData);
    console.log('SelectedProducts:', selectedProducts);
    console.log('SelectedProducts type:', typeof selectedProducts);
    console.log('SelectedProducts length:', selectedProducts?.length);
    console.log('UserInputs:', userInputs);
    console.log('=== FIN DÉBUT SOUMISSION ===');

    // Validation des champs requis
    const requiredFields = ['name', 'email', 'phone_number', 'site_address', 'postal_code', 'city'];
    const missingFields = requiredFields.filter(field => !formData[field] || formData[field].trim() === '');
    
    if (missingFields.length > 0) {
      console.error('Champs manquants:', missingFields);
      throw new Error(`Veuillez remplir tous les champs obligatoires : ${missingFields.join(', ')}`);
    }

    // Préparer les items pour l'API selon le modèle
    const items = selectedProducts.map((product, index) => {
      console.log(`Produit ${index + 1}/${selectedProducts.length}:`, product);
      console.log('  - Nom:', product.name);
      console.log('  - ContentProductId:', product.contentProductId);
      console.log('  - Section:', product.section);
      
      // Validation des IDs
      if (!product.contentProductId) {
        console.error(`❌ ContentProductId manquant pour le produit ${index + 1}:`, product);
        throw new Error(`ContentProductId manquant pour le produit: ${product.name}`);
      }
      
      if (!product.section) {
        console.error(`❌ Section manquante pour le produit ${index + 1}:`, product);
        throw new Error(`Section manquante pour le produit: ${product.name}`);
      }

      // Validation du format UUID
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      if (!uuidRegex.test(product.contentProductId)) {
        console.error(`❌ ContentProductId invalide (pas un UUID) pour le produit ${index + 1}:`, product.contentProductId);
        throw new Error(`ContentProductId invalide pour le produit: ${product.name}`);
      }
      
      if (!uuidRegex.test(product.section)) {
        console.error(`❌ Section invalide (pas un UUID) pour le produit ${index + 1}:`, product.section);
        throw new Error(`Section invalide pour le produit: ${product.name}`);
      }
      
      // Note: Les quantités et prix ne sont pas envoyés à l'API selon le modèle
      // L'API ne reçoit que les IDs de section et content_product
      
      return {
        section: product.section,
        content_product: product.contentProductId
      };
    });
    
    // Log récapitulatif des sections uniques
    const uniqueSections = [...new Set(items.map(item => item.section))];
    console.log('📋 Récapitulatif des items:');
    console.log(`  - Nombre total d'items: ${items.length}`);
    console.log(`  - Nombre de sections uniques: ${uniqueSections.length}`);
    console.log(`  - Sections utilisées:`, uniqueSections);
    
    // Vérifier s'il y a des doublons de sections
    uniqueSections.forEach(sectionId => {
      const itemsInSection = items.filter(item => item.section === sectionId);
      if (itemsInSection.length > 1) {
        console.log(`  ⚠️ Section ${sectionId} utilisée ${itemsInSection.length} fois`);
      }
    });
    
    // Créer un mapping pour le débogage (sans l'inclure dans les données envoyées)
    const itemsDebugMap = selectedProducts.map((product, index) => ({
      index: index + 1,
      productName: product.name,
      section: product.section,
      contentProduct: product.contentProductId
    }));
    console.log('🔍 Mapping des items pour débogage:', itemsDebugMap);

    // Extraire la valeur numérique pour user_input (pour l'API)
    let numericUserInput = 0; // Valeur par défaut
    Object.entries(userInputs).forEach(([sectionId, inputData]) => {
      Object.entries(inputData).forEach(([key, value]) => {
        // Chercher une valeur numérique dans les inputs
        if (typeof value === 'object' && value.value) {
          const numValue = parseFloat(value.value);
          if (!isNaN(numValue) && numValue > 0) {
            numericUserInput = numValue;
          }
        } else if (typeof value === 'string') {
          const numValue = parseFloat(value);
          if (!isNaN(numValue) && numValue > 0) {
            numericUserInput = numValue;
          }
        }
      });
    });

    console.log('🔢 Valeur numérique extraite pour user_input:', numericUserInput);
    
    // Validation stricte de user_input
    if (numericUserInput === 0 || isNaN(numericUserInput)) {
      console.warn('⚠️ Aucune valeur numérique valide trouvée, utilisation de 1 par défaut');
      numericUserInput = 1;
    }

    // Validation finale des données
    const validatedFields = {
      name: formData.name?.trim(),
      email: formData.email?.trim(),
      phone_number: formData.phone_number?.trim(),
      site_address: formData.site_address?.trim(),
      postal_code: formData.postal_code?.trim(),
      city: formData.city?.trim()
    };

    // Debug: Afficher tous les champs du formulaire
    console.log('=== INFORMATIONS DE CONTACT ===');
    console.log('FormData complet:', formData);
    console.log('Champs requis validés:', validatedFields);
    console.log('Champs optionnels:', {
      delivery_instructions: formData.delivery_instructions,
      comments: formData.comments,
      need_installer: formData.need_installer,
      be_reminded: formData.be_reminded
    });
    console.log('=== FIN INFORMATIONS DE CONTACT ===');

    // Vérifier que tous les champs requis sont remplis
    for (const [field, value] of Object.entries(validatedFields)) {
      if (!value || value.length === 0) {
        console.error(`❌ Champ manquant: ${field} = "${value}"`);
        throw new Error(`Le champ ${field} est requis`);
      } else {
        console.log(`✅ Champ valide: ${field} = "${value}"`);
      }
    }

      // Validation finale de user_input
      if (numericUserInput === null || numericUserInput === undefined || isNaN(numericUserInput)) {
        console.warn('⚠️ user_input invalide, utilisation de 1 par défaut');
        numericUserInput = 1;
      }

      // Préparer les données selon le modèle Quote
      quoteData = {
        name: validatedFields.name,
        email: validatedFields.email,
        phone_number: validatedFields.phone_number,
        need_installer: formData.need_installer || false,
        be_reminded: formData.be_reminded || false,
        site_address: validatedFields.site_address,
        postal_code: validatedFields.postal_code,
        city: validatedFields.city,
        delivery_instructions: formData.delivery_instructions?.trim() || null,
        comments: formData.comments?.trim() || null,
        user_input: numericUserInput,
        items: items
      };

    console.log('=== DONNÉES DE SOUMISSION ===');
    console.log('FormData:', formData);
    console.log('SelectedProducts:', selectedProducts);
    console.log('Items détaillés:', items);
    console.log('Valeur numérique extraite:', numericUserInput);
    console.log('QuoteData final:', quoteData);
    console.log('URL de soumission relative:', URLS.QUOTE.create());
    if (API?.defaults?.baseURL) {
      console.log('URL de soumission absolue:', `${API.defaults.baseURL}${URLS.QUOTE.create()}`);
    }
    console.log('🔍 Détail des items envoyés:');
    items.forEach((item, index) => {
      console.log(`Item ${index + 1}:`, {
        section: item.section,
        content_product: item.content_product,
        quantity: item.quantity,
        price: item.price,
        product_type: item.product_type
      });
      
      // Validation de chaque item
      if (!item.section || !item.content_product) {
        console.error(`❌ Item ${index + 1} invalide:`, item);
        throw new Error(`Item ${index + 1} invalide: section ou content_product manquant`);
      }
      // Note: Plus de validation de quantity/price car ils ne sont pas envoyés à l'API
    });
    
    // Logs détaillés pour debug
    console.log('🔍 DEBUG - Produits sélectionnés originaux:');
    selectedProducts.forEach((product, index) => {
      console.log(`Produit original ${index + 1}:`, {
        name: product.name,
        contentProductId: product.contentProductId,
        section: product.section
      });
    });
    
    // Validation des données avant envoi
    console.log('🔍 VALIDATION DES DONNÉES:');
    items.forEach((item, index) => {
      console.log(`Item ${index + 1} avant envoi:`, {
        section: item.section,
        content_product: item.content_product
      });
      
      // Vérifier que les UUIDs sont valides
      if (!item.section || !item.content_product) {
        console.error(`❌ Item ${index + 1}: section ou content_product manquant`);
        throw new Error(`Item ${index + 1}: section ou content_product manquant`);
      }
    });
    console.log('QuoteData complet:', quoteData);
    console.log('🔍 Structure des items envoyés:', items);
    console.log('🔍 Nombre d\'items:', items.length);
    console.log('🔍 Détail de chaque item:');
    items.forEach((item, index) => {
      console.log(`  Item ${index + 1}:`, {
        section: item.section,
        content_product: item.content_product,
        sectionType: typeof item.section,
        contentProductType: typeof item.content_product
      });
    });
    console.log('=== FIN DONNÉES ===');

    console.log('🚀 Envoi de la requête POST vers /quote ...');
    console.log('🚀 === ENVOI DE LA REQUÊTE ===');
    console.log('URL complète:', `${URLS.BASE_URL}${URLS.QUOTE.create()}`);
    console.log('Méthode: POST');
    console.log('Données à envoyer:', JSON.stringify(quoteData, null, 2));

    const response = await API.post(URLS.QUOTE.create(), quoteData);
    
    console.log('✅ === SUCCÈS DE LA SOUMISSION ===');
    console.log('Status:', response.status);
    console.log('Status Text:', response.statusText);
    console.log('Headers:', response.headers);
    console.log('Données de réponse complètes:', response.data);
    
    if (response.data) {
      console.log('✅ DEVIS SOUMIS AVEC SUCCÈS !');
      if (response.data.quote?.id) {
        console.log(`🆔 ID du devis créé: ${response.data.quote.id}`);
      } else if (response.data.id) {
        console.log(`🆔 ID du devis: ${response.data.id}`);
      }
      console.log('📋 Total coût:', response.data.total_cost || 'N/A');
      console.log('📋 Nombre d\'items:', response.data.items?.length || 0);
      console.log('📋 Structure complète de la réponse:', JSON.stringify(response.data, null, 2));
    }
    
    return response.data;
    
  } catch (error) {
    // Logs détaillés pour toutes les erreurs
    console.error('❌ === ERREUR DE SOUMISSION ===');
    console.error('Type d\'erreur:', error.constructor.name);
    console.error('Message d\'erreur:', error.message);
    console.error('Stack trace:', error.stack);
    
    // Informations sur la réponse HTTP si disponible
    if (error.response) {
      console.error('📡 === RÉPONSE HTTP ===');
      console.error('Status:', error.response.status);
      console.error('Status Text:', error.response.statusText);
      console.error('Headers:', error.response.headers);
      console.error('Données de réponse:', error.response.data);
      console.error('Structure de l\'erreur:', JSON.stringify(error.response.data, null, 2));
      
      // Messages d'erreur spécifiques selon le code de statut
      if (error.response.status === 400) {
        console.error('❌ Erreur 400 - Requête invalide. Vérifiez les données envoyées.');
        if (error.response.data) {
          console.error('Détails de l\'erreur:', error.response.data);
        }
      } else if (error.response.status === 401) {
        console.error('❌ Erreur 401 - Non autorisé. Vérifiez l\'authentification.');
      } else if (error.response.status === 403) {
        console.error('❌ Erreur 403 - Accès interdit.');
      } else if (error.response.status === 404) {
        console.error('❌ Erreur 404 - Endpoint non trouvé:', URLS.QUOTE.create());
      } else if (error.response.status === 500) {
        console.error('❌ Erreur 500 - Erreur serveur interne.');
        console.error('Le serveur a rencontré une erreur lors du traitement de la requête.');
        console.error('🔍 Détails complets de l\'erreur serveur:');
        console.error('  - Type de données:', typeof error.response.data);
        console.error('  - Données brutes:', error.response.data);
        if (error.response.data) {
          if (typeof error.response.data === 'string') {
            console.error('  - Message d\'erreur (string):', error.response.data);
          } else if (typeof error.response.data === 'object') {
            console.error('  - Clés de l\'objet:', Object.keys(error.response.data));
            if (error.response.data.error) {
              console.error('  - Champ "error":', error.response.data.error);
            }
            if (error.response.data.message) {
              console.error('  - Champ "message":', error.response.data.message);
            }
            if (error.response.data.detail) {
              console.error('  - Champ "detail":', error.response.data.detail);
            }
            console.error('  - Objet complet:', JSON.stringify(error.response.data, null, 2));
          }
        }
      } else if (error.response.status >= 500) {
        console.error(`❌ Erreur ${error.response.status} - Erreur serveur.`);
        console.error('Données de réponse:', error.response.data);
      }
    } else if (error.request) {
      console.error('📡 === REQUÊTE ENVOYÉE MAIS PAS DE RÉPONSE ===');
      console.error('La requête a été envoyée mais aucune réponse n\'a été reçue.');
      console.error('URL:', error.config?.url || 'N/A');
      console.error('Méthode:', error.config?.method || 'N/A');
      console.error('Timeout configuré:', error.config?.timeout || 'N/A');
    } else {
      console.error('📡 === ERREUR DE CONFIGURATION ===');
      console.error('Une erreur s\'est produite lors de la configuration de la requête.');
    }
    
    // Informations sur la requête
    if (error.config) {
      console.error('📤 === DÉTAILS DE LA REQUÊTE ===');
      console.error('URL complète:', error.config.url || 'N/A');
      console.error('Base URL:', error.config.baseURL || 'N/A');
      console.error('Méthode:', error.config.method || 'N/A');
      console.error('Timeout:', error.config.timeout || 'N/A');
      console.error('Headers:', error.config.headers || 'N/A');
      if (error.config.data) {
        try {
          const dataParsed = typeof error.config.data === 'string' 
            ? JSON.parse(error.config.data) 
            : error.config.data;
          console.error('Données envoyées:', JSON.stringify(dataParsed, null, 2));
        } catch (e) {
          console.error('Données envoyées (raw):', error.config.data);
        }
      }
    }
    
    console.error('=== FIN ERREUR ===');
    
    // Gestion spécifique des timeouts
    if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
      console.log('⏰ Timeout de la requête - Le serveur prend trop de temps à répondre');
      console.log('ℹ️ Le devis pourrait être en cours de traitement côté serveur');
      
      // Retourner un succès partiel pour les timeouts
      return { 
        success: true, 
        message: 'Devis en cours de traitement (timeout serveur)',
        items: quoteData?.items || [],
        total_cost: 0,
        quote: { id: 'timeout-' + Date.now() },
        timeout: true
      };
    }
    
    // Si c'est une erreur 500, vérifier si c'est une erreur connue qui indique que le devis a été sauvegardé
    if (error.response?.status === 500 && quoteData) {
      const errorData = error.response.data;
      const errorMessage = typeof errorData === 'string' 
        ? errorData 
        : errorData?.error || errorData?.message || errorData?.detail || '';
      
      console.log('🔍 Analyse de l\'erreur 500:');
      console.log('  - Type de données:', typeof errorData);
      console.log('  - Message d\'erreur extrait:', errorMessage);
      
      // Liste des erreurs connues qui indiquent que le devis a été sauvegardé malgré l'erreur
      const knownErrors = [
        "unsupported operand type(s) for *: 'NoneType' and 'float'",
        "unsupported operand type",
        "NoneType",
        "Internal Server Error"
      ];
      
      // Liste des erreurs de validation qui indiquent un problème avec les données
      const validationErrors = [
        "Section matching query does not exist",
        "ContentProduct matching query does not exist",
        "does not exist"
      ];
      
      const isValidationError = validationErrors.some(validationError => 
        errorMessage.includes(validationError) || 
        (typeof errorData === 'string' && errorData.includes(validationError))
      );
      
      if (isValidationError) {
        console.error('❌ === ERREUR DE VALIDATION ===');
        console.error('Une section ou un content_product envoyé n\'existe pas dans la base de données.');
        console.error('Message d\'erreur:', errorMessage);
        
        // Identifier quelles sections ont été envoyées
        if (quoteData && quoteData.items) {
          console.error('🔍 Sections envoyées dans la requête:');
          const sectionsSent = [...new Set(quoteData.items.map(item => item.section))];
          sectionsSent.forEach((sectionId, index) => {
            const itemsInSection = quoteData.items.filter(item => item.section === sectionId);
            console.error(`  ${index + 1}. Section ID: ${sectionId} (utilisée ${itemsInSection.length} fois)`);
            itemsInSection.forEach((item, itemIndex) => {
              console.error(`     - Item ${itemIndex + 1}: content_product = ${item.content_product}`);
            });
          });
          
          console.error('💡 Solution: Vérifiez que toutes les sections existent dans le projet sélectionné.');
          console.error('💡 Il se peut qu\'une section ait été supprimée ou modifiée côté backend.');
          console.error('💡 Vérifiez également que vous utilisez le bon projet et que les sections sont à jour.');
        }
        
        // Créer un message d'erreur plus détaillé
        const detailedError = new Error(
          `Erreur de validation: ${errorMessage}\n\n` +
          `Une section ou un produit envoyé n'existe pas dans la base de données.\n` +
          `Vérifiez que toutes les sections du projet sont valides et à jour.`
        );
        detailedError.name = 'ValidationError';
        detailedError.status = 500;
        detailedError.originalMessage = errorMessage;
        
        throw detailedError;
      }
      
      const isKnownError = knownErrors.some(knownError => 
        errorMessage.includes(knownError) || 
        (typeof errorData === 'string' && errorData.includes(knownError))
      );
      
      if (isKnownError) {
        console.warn('⚠️ Erreur serveur connue - Le statut de sauvegarde est incertain');
        console.warn('ℹ️ Cette erreur est liée à un problème de calcul côté serveur');
        console.warn('ℹ️ Le devis pourrait ne pas avoir été sauvegardé en base de données');
        console.warn('📦 Données du devis envoyées:', {
          name: quoteData.name,
          email: quoteData.email,
          items_count: quoteData.items?.length || 0,
          user_input: quoteData.user_input
        });
        
        // Ne pas considérer cela comme un succès - c'est une vraie erreur
        // L'utilisateur doit être informé que le devis n'a peut-être pas été sauvegardé
        const validationError = new Error(
          `Erreur serveur lors de la sauvegarde du devis.\n\n` +
          `Une erreur s'est produite côté serveur lors du calcul du devis.\n` +
          `Le devis pourrait ne pas avoir été sauvegardé.\n\n` +
          `Veuillez réessayer ou contacter le support si le problème persiste.`
        );
        validationError.name = 'ServerCalculationError';
        validationError.status = 500;
        validationError.originalMessage = errorMessage;
        validationError.isKnownError = true;
        
        throw validationError;
      } else {
        console.error('❌ Erreur 500 inconnue - Le devis n\'a peut-être pas été sauvegardé');
        console.error('Message d\'erreur:', errorMessage);
        console.error('Données complètes de l\'erreur:', errorData);
        console.error('Veuillez vérifier avec l\'équipe backend si le devis a été sauvegardé');
        console.error('🔍 Pour déboguer, vérifiez:');
        console.error('  1. Les logs du serveur backend');
        console.error('  2. Si le devis apparaît dans la base de données');
        console.error('  3. Le format exact attendu par l\'API');
      }
    }
    
    // Log final avant de relancer l'erreur
    console.error('🚨 === RELANCE DE L\'ERREUR ===');
    console.error('L\'erreur va être relancée pour être gérée par le composant appelant');
    console.error('Type:', error.constructor.name);
    console.error('Message:', error.message);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
    }
    
    throw error;
  }
};
